/**
 * SmartdineNow API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { Observable } from 'rxjs';

import { SmartDineResponseImageInfoModel } from '../model/smartDineResponseImageInfoModel';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';


@Injectable()
export class SmartdineImageRestControllerService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param fileKey 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param menuId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteFile(fileKey: string, restaurantId?: string, restaurantBranchId?: string, menuId?: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseImageInfoModel>;
    public deleteFile(fileKey: string, restaurantId?: string, restaurantBranchId?: string, menuId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseImageInfoModel>>;
    public deleteFile(fileKey: string, restaurantId?: string, restaurantBranchId?: string, menuId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseImageInfoModel>>;
    public deleteFile(fileKey: string, restaurantId?: string, restaurantBranchId?: string, menuId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (fileKey === null || fileKey === undefined) {
            throw new Error('Required parameter fileKey was null or undefined when calling deleteFile.');
        }




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (restaurantId !== undefined && restaurantId !== null) {
            queryParameters = queryParameters.set('restaurantId', <any>restaurantId);
        }
        if (restaurantBranchId !== undefined && restaurantBranchId !== null) {
            queryParameters = queryParameters.set('restaurantBranchId', <any>restaurantBranchId);
        }
        if (menuId !== undefined && menuId !== null) {
            queryParameters = queryParameters.set('menuId', <any>menuId);
        }
        if (fileKey !== undefined && fileKey !== null) {
            queryParameters = queryParameters.set('fileKey', <any>fileKey);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmartDineResponseImageInfoModel>('delete',`${this.basePath}/api/admin/images/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param fileKey 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public forwardToUrl(fileKey: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public forwardToUrl(fileKey: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public forwardToUrl(fileKey: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public forwardToUrl(fileKey: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (fileKey === null || fileKey === undefined) {
            throw new Error('Required parameter fileKey was null or undefined when calling forwardToUrl.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<string>('post',`${this.basePath}/api/admin/images/url/${encodeURIComponent(String(fileKey))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param menuId 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getImages(menuId: string, restaurantId?: string, restaurantBranchId?: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseImageInfoModel>;
    public getImages(menuId: string, restaurantId?: string, restaurantBranchId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseImageInfoModel>>;
    public getImages(menuId: string, restaurantId?: string, restaurantBranchId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseImageInfoModel>>;
    public getImages(menuId: string, restaurantId?: string, restaurantBranchId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (menuId === null || menuId === undefined) {
            throw new Error('Required parameter menuId was null or undefined when calling getImages.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (restaurantId !== undefined && restaurantId !== null) {
            queryParameters = queryParameters.set('restaurantId', <any>restaurantId);
        }
        if (restaurantBranchId !== undefined && restaurantBranchId !== null) {
            queryParameters = queryParameters.set('restaurantBranchId', <any>restaurantBranchId);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmartDineResponseImageInfoModel>('get',`${this.basePath}/api/admin/images/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param fileKey 
     * @param file 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param menuId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateFileForm(fileKey: string, file?: Blob, restaurantId?: string, restaurantBranchId?: string, menuId?: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseImageInfoModel>;
    public updateFileForm(fileKey: string, file?: Blob, restaurantId?: string, restaurantBranchId?: string, menuId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseImageInfoModel>>;
    public updateFileForm(fileKey: string, file?: Blob, restaurantId?: string, restaurantBranchId?: string, menuId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseImageInfoModel>>;
    public updateFileForm(fileKey: string, file?: Blob, restaurantId?: string, restaurantBranchId?: string, menuId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (fileKey === null || fileKey === undefined) {
            throw new Error('Required parameter fileKey was null or undefined when calling updateFile.');
        }





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (restaurantId !== undefined && restaurantId !== null) {
            queryParameters = queryParameters.set('restaurantId', <any>restaurantId);
        }
        if (restaurantBranchId !== undefined && restaurantBranchId !== null) {
            queryParameters = queryParameters.set('restaurantBranchId', <any>restaurantBranchId);
        }
        if (menuId !== undefined && menuId !== null) {
            queryParameters = queryParameters.set('menuId', <any>menuId);
        }
        if (fileKey !== undefined && fileKey !== null) {
            queryParameters = queryParameters.set('fileKey', <any>fileKey);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (file !== undefined) {
            formParams = formParams.append('file', <any>file) as any || formParams;
        }

        return this.httpClient.request<SmartDineResponseImageInfoModel>('put',`${this.basePath}/api/admin/images/`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param file 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param menuId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public uploadFileForm(file?: Blob, restaurantId?: string, restaurantBranchId?: string, menuId?: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseImageInfoModel>;
    public uploadFileForm(file?: Blob, restaurantId?: string, restaurantBranchId?: string, menuId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseImageInfoModel>>;
    public uploadFileForm(file?: Blob, restaurantId?: string, restaurantBranchId?: string, menuId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseImageInfoModel>>;
    public uploadFileForm(file?: Blob, restaurantId?: string, restaurantBranchId?: string, menuId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (restaurantId !== undefined && restaurantId !== null) {
            queryParameters = queryParameters.set('restaurantId', <any>restaurantId);
        }
        if (restaurantBranchId !== undefined && restaurantBranchId !== null) {
            queryParameters = queryParameters.set('restaurantBranchId', <any>restaurantBranchId);
        }
        if (menuId !== undefined && menuId !== null) {
            queryParameters = queryParameters.set('menuId', <any>menuId);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (file !== undefined) {
            formParams = formParams.append('file', <any>file) as any || formParams;
        }

        return this.httpClient.request<SmartDineResponseImageInfoModel>('post',`${this.basePath}/api/admin/images/`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
